(function () {
  if (window.PromoPopupEngine) return;

  var EMAIL_KEYS = ['customerEmail', 'emailMailchimp'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var MOBILE_BREAKPOINT = 550;
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // Cross-instance coordination so at most one enabled popup auto-opens,
  // even if a merchant accidentally enables two at once.
  var registeredPopups = [];
  var activeAutoOpenId = null;

  function normalizePathname(pathname) {
    if (!pathname || pathname === '/') return pathname || '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function isValidEmail(v) {
    return typeof v === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  function hasStoredEmail() {
    for (var i = 0; i < EMAIL_KEYS.length; i++) {
      try {
        var value = localStorage.getItem(EMAIL_KEYS[i]);
        if (typeof value === 'string' && value.trim() !== '') return true;
      } catch (e) {}
    }
    return false;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function isMobileViewport() {
    try {
      return window.matchMedia && window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
    } catch (e) {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }
  }

  function getUtmParams() {
    var out = {};
    for (var i = 0; i < UTM_KEYS.length; i++) {
      try {
        var v = sessionStorage.getItem(UTM_KEYS[i]);
        if (v) out[UTM_KEYS[i]] = v;
      } catch (e) {}
    }
    return out;
  }

  async function createCustomerInShopify(email) {
    try {
      var response = await fetch(
        'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_createCustomer/' +
          encodeURIComponent(email)
      );
      if (!response.ok) throw new Error('Customer creation failed');
      return await response.json();
    } catch (error) {
      console.error('createCustomerInShopify (promo popup engine)', error);
      return null;
    }
  }

  function PromoPopup(config) {
    this.config = config || {};
    this.id = this.config.id;
    this.storageKeyPrefix = this.config.storageKeyPrefix || this.id;
    this.rootEl = this.config.rootEl;
    this.backdropEl = this.config.backdropEl || null;
    this.shellEl = this.config.shellEl || this.rootEl;
    this.autoOpenDelayMs = typeof this.config.autoOpenDelayMs === 'number' ? this.config.autoOpenDelayMs : 10000;
    this.suppressedPaths = this.config.suppressedPaths || [];
    this.alwaysShowForTesting = !!this.config.alwaysShowForTesting;
    this.debugQueryParam = this.config.debugQueryParam || 'debug-' + this.id;

    this._autoOpenTimer = null;
    this._isOpen = false;
    this._bodyScrollY = 0;
    this._lastFocusedEl = null;
    this._onKeydown = this._onKeydown.bind(this);

    registeredPopups.push(this);
    this._bindDismissTriggers();
  }

  PromoPopup.prototype._dismissedStorageKey = function () {
    return this.storageKeyPrefix + '_dismissed_v1';
  };

  PromoPopup.prototype._isAlwaysShowEnabled = function () {
    if (this.alwaysShowForTesting) return true;
    try {
      return new URL(window.location.href).searchParams.has(this.debugQueryParam);
    } catch (e) {
      return false;
    }
  };

  PromoPopup.prototype._persistDismissed = function () {
    if (this._isAlwaysShowEnabled()) return;
    try {
      localStorage.setItem(this._dismissedStorageKey(), 'true');
    } catch (e) {}
  };

  PromoPopup.prototype._isDismissedPersisted = function () {
    try {
      return localStorage.getItem(this._dismissedStorageKey()) === 'true';
    } catch (e) {
      return false;
    }
  };

  PromoPopup.prototype.isSuppressedForPath = function () {
    var p = '';
    try {
      p = normalizePathname(window.location.pathname || '');
    } catch (e) {
      return false;
    }
    return this.suppressedPaths.indexOf(p) !== -1;
  };

  PromoPopup.prototype.hasStoredEmail = hasStoredEmail;
  PromoPopup.prototype.prefersReducedMotion = prefersReducedMotion;
  PromoPopup.prototype.isValidEmail = isValidEmail;

  PromoPopup.prototype._isSuppressed = function (force) {
    if (force) return false;
    if (window.__nutricodeSkipThemeInitialPopups === true) return true;
    if (this._isAlwaysShowEnabled()) return this.isSuppressedForPath();
    return this.isSuppressedForPath() || this.hasStoredEmail() || this._isDismissedPersisted();
  };

  PromoPopup.prototype._lockScroll = function () {
    this._bodyScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('ppe-popup-scroll-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = -this._bodyScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  PromoPopup.prototype._unlockScroll = function () {
    document.documentElement.classList.remove('ppe-popup-scroll-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this._bodyScrollY);
  };

  PromoPopup.prototype._onKeydown = function (e) {
    if (!this._isOpen) return;

    if (e.key === 'Escape') {
      this.dismiss('escape');
      return;
    }

    if (e.key === 'Tab' && this.shellEl) {
      var focusable = Array.prototype.slice.call(this.shellEl.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  PromoPopup.prototype._bindDismissTriggers = function () {
    if (this.backdropEl) {
      var self = this;
      this.backdropEl.addEventListener('click', function () {
        self.dismiss('backdrop');
      });
    }
  };

  PromoPopup.prototype.show = function (force) {
    if (this._isOpen) return;
    if (this._isSuppressed(force)) return;

    this._clearAutoOpenTimer();
    this._lastFocusedEl = document.activeElement;
    this._isOpen = true;
    this._lockScroll();
    document.addEventListener('keydown', this._onKeydown);

    if (typeof this.config.onBeforeShow === 'function') this.config.onBeforeShow();
    if (typeof this.config.onAfterShow === 'function') this.config.onAfterShow();
  };

  PromoPopup.prototype.hide = function () {
    if (!this._isOpen) return;
    this._isOpen = false;

    if (typeof this.config.onBeforeHide === 'function') this.config.onBeforeHide();

    document.removeEventListener('keydown', this._onKeydown);
    this._unlockScroll();

    if (this._lastFocusedEl && typeof this._lastFocusedEl.focus === 'function') {
      try {
        this._lastFocusedEl.focus();
      } catch (e) {}
    }

    if (typeof this.config.onAfterHide === 'function') this.config.onAfterHide();
  };

  PromoPopup.prototype.dismiss = function (reason) {
    this._clearAutoOpenTimer();
    this._persistDismissed();
    this.hide();
    if (typeof this.config.onDismiss === 'function') this.config.onDismiss(reason);
  };

  PromoPopup.prototype._clearAutoOpenTimer = function () {
    if (this._autoOpenTimer) {
      clearTimeout(this._autoOpenTimer);
      this._autoOpenTimer = null;
    }
  };

  PromoPopup.prototype.scheduleAutoOpen = function () {
    if (this._isSuppressed(false)) return;

    if (activeAutoOpenId !== null && activeAutoOpenId !== this.id) {
      console.warn(
        'PromoPopupEngine: "' + this.id + '" did not auto-open because "' + activeAutoOpenId + '" already claimed the auto-open slot.'
      );
      return;
    }
    activeAutoOpenId = this.id;

    var self = this;
    this._autoOpenTimer = window.setTimeout(function () {
      self._autoOpenTimer = null;
      if (self._isOpen) return;
      if (!self._isAlwaysShowEnabled() && self.hasStoredEmail()) return;
      self.show(false);
    }, this.autoOpenDelayMs);
  };

  PromoPopup.prototype.submitToMailchimp = async function (email, tags) {
    try {
      localStorage.setItem('emailMailchimp', email);
    } catch (e) {}

    var tagPromise = Promise.resolve();
    if (typeof globalAddTags === 'function') {
      tagPromise = globalAddTags(tags, email).catch(function (err) {
        console.error('globalAddTags (promo popup engine)', err);
        throw err;
      });
    } else {
      console.warn('globalAddTags is not available (promo popup engine)');
    }

    var customerPromise = createCustomerInShopify(email);
    var results = await Promise.all([tagPromise, customerPromise]);
    return { tagsResult: results[0], customerResult: results[1] };
  };

  PromoPopup.prototype.track = function (eventName, extraParams, opts) {
    opts = opts || {};
    var params = Object.assign(
      {
        popup_name: this.config.name || this.id,
        page_url: window.location.href,
        device_type: isMobileViewport() ? 'mobile' : 'desktop',
        visitor_type: this.hasStoredEmail() ? 'returning' : 'new'
      },
      getUtmParams(),
      extraParams || {}
    );

    if (typeof window.trackGoogle === 'function') {
      window.trackGoogle(eventName, params);
    }
    if (opts.meta && typeof window.trackMeta === 'function') {
      window.trackMeta(eventName, params);
    }
  };

  window.PromoPopupEngine = {
    create: function (config) {
      return new PromoPopup(config);
    }
  };
})();
